module.exports = __webpack_public_path__ + "img/chanpin_6@2x.91bbcaa7.png";